import Dropdown from "./Dropdown";
import Plus from "./Plus";
import Minus from "./Minus";
import Chevron from "./Chevron";
import Tick from "./Tick";
import PersonPin from "./PersonPin";
import Info from "./Info";
import Close from "./Close";
import TV from "./TV";

const Icon = ({ children }) => <>{children}</>;


Icon.Dropdown = Dropdown;
Icon.Plus = Plus;
Icon.Minus = Minus;
Icon.Chevron = Chevron;
Icon.Tick = Tick;
Icon.PersonPin = PersonPin;
Icon.Info = Info;
Icon.Close = Close;
Icon.TV = TV;

export default Icon;
